<template>
  <div class="swiper-container">
    <!-- swiper1 -->
    <swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop">
      <swiper-slide class="slide-1" v-for="(item, i) in items" :key="i">
        <img :src="item.src" alt />
      </swiper-slide>
      <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
      <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
    </swiper>
    <!-- swiper2 Thumbs -->
    <swiper :options="swiperOptionThumbs" class="gallery-thumbs" ref="swiperThumbs">
      <swiper-slide class="slide-1" v-for="(item, i) in items" :key="i">
        <img :src="item.src" alt />
      </swiper-slide>
    </swiper>
  </div>
</template>


<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";

import "swiper/dist/css/swiper.css";

export default {
  props: ["items"],
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOptionTop: {
        spaceBetween: 10,
        loop: true,
        loopedSlides: 3,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      swiperOptionThumbs: {
        spaceBetween: 10,
        slidesPerView: 3,
        touchRatio: 0.2,
        loop: true,
        loopedSlides: 3,
        slideToClickedSlide: true
      }
    };
  },
  mounted() {
    this.$nextTick(() => {
      const swiperTop = this.$refs.swiperTop.swiper;
      const swiperThumbs = this.$refs.swiperThumbs.swiper;
      swiperTop.controller.control = swiperThumbs;
      swiperThumbs.controller.control = swiperTop;
    });
  }
};
</script>

<style lang="scss">
.swiper-wrapper {
  // display: flex;
  // flex-direction: column;
  // justify-content: center;
}
.swiper-container {
  max-width: 600px;
  // max-height: 400px;
  height: auto;
  /* background-color: #000; */
}
.swiper-slide {
  width: 100%;
  height: auto;
  // background-size: contain;
  // background-position: center;
  img {
    width: 100%;
    height: auto;
    // background-size: contain;
    // object-fit: contain;
    // background-position: center;
  }
}
.gallery-top {
  height: 80% !important;
  width: 100%;
}
.gallery-thumbs {
  height: 20% !important;
  box-sizing: border-box;
  padding: 10px 0;
}
.gallery-thumbs .swiper-slide {
  width: 25%;
  height: 100%;
  opacity: 0.4;
}
.gallery-thumbs .swiper-slide-active {
  opacity: 1;
}
</style>